var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.data.labels),function(label){return _c('div',[_c('span',{staticClass:"label label-primary"},[_vm._v(_vm._s(label.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }